module.exports = __webpack_public_path__ + "web/img/chapter-30.b68bf2b5.png";